// Checklist - PAVADINIMAS (puslapis)

page.checklist.MARKET = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    check: function(){ // Šitą funkciją vykdo kai tikrina užkrauto puslapio DOM, ieško elementų
        this.reset();
        if(page.v.firstLoad) this.first(); // Pirmą kart užkrovus tinklapį galima susikurti kažkokius pastovius kintamuosius ir t.t.

        if($('.market-table').length > 0){ // jei randi reikiamą elementą - modulis įjungiamas.
            log.page("CHECK: MARKET detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){ // Ši funkcija vykdoma iškart po DOM apdorojimo, galima kabint eventus ir t.t.

        //page.control.bg.fadeColor(0, 2000);
        let name = $('.barba-container').data('namespace');
        page.transitions(name, 900);
        page.popupforms.init();


        /* page.control.particles.speedTo(0.1, 1000);
        page.control.particles.fadeTo(0.5, 1500);
        page.control.particles.scrolling(true); */

      /*  $.ajax({
            data: {action: 'reinit'},
            type: 'post',
            url: 'https://localhost/agrorodeo.lt/wp-admin/admin-ajax.php',
            success: function (data) {
                console.log(data);
            }
        });*/

        page.main.fr.newsletter.init();
        page.main.fr.tableExpand.init();
        page.main.fr.tableChange.init();
        page.main.fr.floatLabels.init();
        page.main.fr.altMenu.default();
        page.main.v.marketSticky.reverse();


        let left = $('.altMark-container').scrollLeft();

        $('.altMark-container').on('scroll', function(){
            if($('.altMark-headers--wrap').hasClass('is-sticky')){
                $('.altMark-headers').css({left: -$('.altMark-container').scrollLeft()})
            }
        });


        const elPass = document.querySelector('.btn-show-password');
        if(elPass) {
            elPass.addEventListener('click', () => {
                elPass.parentNode.classList.toggle('show');
                const input = elPass.parentNode.querySelector('input');
                input.type = input.type == 'password' ? 'text' : 'password';
            });
        }

      /*  $('.popup-trigger').click(function(e){
            e.preventDefault();
            console.log('trigger');
            let $this = $(this);
            let target = $this.data('target');
            $('.news-popup').removeClass('active');
            $('.news-popup.'+target).addClass('active');

            $('.news-reminder').removeClass('active');
            $('.news-login').addClass('active');
        });

        $('.news-popup--close').click(function(e){
            e.preventDefault();
            $(this).parent().removeClass('active');
        });

        $('.news-register').submit(function(e){
           e.preventDefault();
           let $this = $(this);
           let data = $this.serialize();
            $.ajax({
                data: data,
                type: 'post',
                url: ajaxurl,
                success: function (data) {
                    console.log(data);
                    $this.hide();
                    $('.register-succes').show();
                }
            });
        });

        $(".swap-forms").click(function(e){
            e.preventDefault();
            $('.news-login').toggleClass('active');
            $('.news-reminder').toggleClass('active');
        });
        // what about bob

        $('.news-login').submit(function(e){
            e.preventDefault();

            let $this = $(this);
            let data = $this.serialize();
            $.ajax({
                data: data,
                type: 'post',
                url: ajaxurl,
                success: function (data) {
                    data = JSON.parse(data);
                    console.log(data);
                    if(data.status == 1 && data.redirect == true){

                        Barba.Pjax.goTo( $this.find('.form-redirect').attr('href'));
                        console.log('should be clicked');
                    }
                    //$this.hide();
                    //$('.register-succes').show();
                }
            });



        });*/

        this.resize();

    },
    first: function(){ // Ši funkcija vykdoma pirmą kartą užkrovus tinklapį

    },
    unload: function(){ // Ši funkcija skirta išvalyti eventams prieš nukraunant puslapį per ajax.
        page.main.fr.newsletter.destroy();
        page.main.fr.tableExpand.destroy();
        page.main.fr.floatLabels.destroy();
        page.main.fr.tableChange.destroy();


    },
    calc: function(){ // Ši funkcija vykdoma kiekvieno kadro metu (animacijoms ir t.t.)

    },
    resize: function(){ // onResize funkcija (pati administruojasi, nereikia atrišinėti)
        let $tableHeader = $('.altMark-headers--wrap');
        if($tableHeader.hasClass('is-sticky')){
            $('.altMark-headers').css({left: $('.altMark').offset().left})
        }else{
            $('.altMark-headers').css({left: 0})
        }
    },
    scroll: function(){ // onScroll funkcija (pati administruojasi)

        let $tableHeader = $('.altMark-headers--wrap');
        let winPos = $(window).scrollTop();
        let headerOffset = $tableHeader.offset().top;

        let tableHeight = $('.altMark-container').height();
        if($tableHeader.length > 0 ){

            let pos = headerOffset - winPos ;
            let tableBot = headerOffset + tableHeight;

            if(pos <= 0 && tableBot > winPos + 50){
                $tableHeader.addClass('is-sticky');
                $('.altMark-headers').css({left:$('.altMark').offset().left})

            }else{
                $('.altMark-headers').css({left: 0});
                if($tableHeader.hasClass('is-sticky')){
                    $tableHeader.removeClass('is-sticky')
                }
            }
        }
    },
    v: {
        // Jei reikalingi vidiniai kintamieji programos darbui, kurie turi išlikti tarp funkcijų vydymo
    },
    f: {
        // Jei reikalingos papildomos vidinės funkcijos modulio veikimui
    }
}